import { Component, Vue, Prop } from "vue-property-decorator";
import vueScroll from "vuescroll";

@Component({
    components: {
        vueScroll
    }
})
export default class Outline extends Vue {
    @Prop() readonly item: any;
    private ops: any = {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(255, 255, 255, .4)"
        }
    };
    mounted() {
        this.$set(this.item.children[0], "moduleCollapse", true);
        this.item.children.forEach(item => {
            let type = item.children[0].children[0].children[0].unlockType;
            let time = item.children[0].children[0].children[0].unlockProps;
            let date = new Date(time);
            if (type === "FIXED_DAY" && date.valueOf() > Number(new Date())) {
                this.$set(item, "lockIcon", true);
            } else {
                this.$set(item, "lockIcon", false);
            }
        });
    }
    handleShowList(item) {
        let type = item.children[0].children[0].children[0].unlockType;
        let time = item.children[0].children[0].children[0].unlockProps;
        let date = new Date(time);
        if (type === "FIXED_DAY" && date.valueOf() > Number(new Date())) {
            this.$set(item, "moduleCollapse", false);
            this.$message.warning("还没到开课时间");
        } else {
            this.$set(item, "moduleCollapse", !item.moduleCollapse);
        }
    }
}
// @ts-ignore
export { default as Outline } from "./index.vue";
